import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint, size } from '@twisto/styles'

import type { Size, Variant } from './tag'

export const container = css`
  display: grid;
  position: relative;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  border-radius: ${size[20]};
  column-gap: ${size[4]};
  align-items: center;

  ${breakpoint.up('sm')} {
    column-gap: ${size[8]};
  }
`

export const containerSize: Record<Size, SerializedStyles> = {
  small: css`
    padding: ${size[4]} ${size[8]};

    ${breakpoint.up('sm')} {
      padding: 6px ${size[8]};
    }
  `,
  medium: css`
    padding: 6px ${size[8]};

    ${breakpoint.up('sm')} {
      padding: ${size[8]} ${size[12]};
    }
  `,
}

export const background: Record<Variant, (theme: Theme) => SerializedStyles> = {
  success: (theme) => css`
    background-color: ${theme.palette.success[100]};
  `,
  warning: (theme) => css`
    background-color: ${theme.palette.warning[100]};
  `,
  error: (theme) => css`
    background-color: ${theme.palette.error[100]};
  `,
  highlight: (theme) => css`
    background-color: ${theme.palette.brand[100]};
  `,
  default: (theme) => css`
    background-color: ${theme.palette.neutral[100]};
  `,
}
